module.exports = __webpack_public_path__ + "static/media/right-bg.f113c2a2.png";